import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PaymentProcessingSettingsPageRoutingModule } from './payment-processing-settings-routing.module';

import { PaymentProcessingSettingsPage } from './payment-processing-settings.page';


import { SharedModule } from "../../shared.module";
import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';
import { ConnectCardReaderPageModule} from "./connect-card-reader/connect-card-reader.module";
import { SalonMonsterSmallCheckMarkLoaderModule } from '../../components/smr-small-checkmark-loader/smr-small-checkmark-loader.module';
import { MailingAddressComponentModule } from '../../components/mailing-address/mailing-address.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PaymentProcessingSettingsPageRoutingModule,
    SharedModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    ConnectCardReaderPageModule,
    SalonMonsterSmallCheckMarkLoaderModule,
    MailingAddressComponentModule
  ],
  declarations: [PaymentProcessingSettingsPage]
})
export class PaymentProcessingSettingsPageModule {}
